import React from "react";
import { ProductStructList } from "../../../structs/ProductStructList";
import { ProductStruct } from "../../../structs/ProductStruct";
import { BASE_URL_API, PRODUCT_BASE_URL_API } from "../../../Const";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";

export class ProductComponentSetareh extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productList: [],
            sheetOpen: false,
            selected: null,
            iOS:
                typeof navigator !== "undefined" &&
                /iPad|iPhone|iPod/.test(navigator.userAgent),

            activeCatKey: null,      // which chip is active
            stickyTotal: 90,         // measured total offset to keep titles visible
        };

        // Refs
        this.topBarRef = null;                 // sticky chips bar
        this.categoryRefs = new Map();         // key -> section
        this.categoryTitleRefs = new Map();    // key -> title <Typography>

        // Scroll-spy
        this.positions = []; // [{key, top}]
        this.raf = null;
    }

    /** ---------- Normalize category titles to stable keys ---------- */
    cleanTitle = (s = "") =>
        String(s)
            .normalize("NFC")
            .replace(/[\u064B-\u065F\u0670]/g, "") // Arabic diacritics
            .replace(/[\u200c\u200d\u200e\u200f\u202a-\u202e]/g, "") // ZWNJ/ZWJ/LRM/RLM/LRE..RLE..PDF
            .replace(/\s+/g, " ")
            .trim();

    keyOf = (s = "") => this.cleanTitle(s).toLowerCase();

    /** ---------- Measure sticky bar + app bar and store as stickyTotal ---------- */
    measureSticky = () => {
        const appOffset = this.props.stickyOffset ?? 0; // your AppBar height
        const barH = this.topBarRef?.offsetHeight ?? 0; // chips bar height
        const gap = 8;                                  // small breathing space
        const stickyTotal = appOffset + barH + gap;
        if (stickyTotal !== this.state.stickyTotal) {
            this.setState({ stickyTotal }, () => this.recomputePositions());
        } else {
            this.recomputePositions();
        }
    };

    /** ---------- Scroll to a category TITLE using exact stickyTotal ---------- */
    scrollToCategory = (catKeyOrTitle) => {
        const key = this.categoryRefs.has(catKeyOrTitle)
            ? catKeyOrTitle
            : this.keyOf(catKeyOrTitle);

        const titleEl =
            this.categoryTitleRefs.get(key) || this.categoryRefs.get(key);
        if (!titleEl) return;

        // highlight immediately
        this.setState({ activeCatKey: key });

        // precise manual scroll using measured stickyTotal
        const y =
            titleEl.getBoundingClientRect().top +
            window.pageYOffset -
            this.state.stickyTotal - 10;

        window.scrollTo({ top: y, behavior: "smooth" });

        // refresh spy soon after scroll starts
        setTimeout(() => {
            this.recomputePositions();
            this.onScrollSpy();
        }, 250);
    };

    /** ---------- Build title top positions for the spy ---------- */
    recomputePositions = () => {
        const offset = this.state.stickyTotal;
        this.positions = Array.from(this.categoryTitleRefs.entries())
            .map(([key, el]) => ({
                key,
                top: el.getBoundingClientRect().top + window.pageYOffset - offset,
            }))
            .sort((a, b) => a.top - b.top);
    };

    /** ---------- Scroll spy (last title whose top <= scrollY) ---------- */
    onScrollSpy = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
            this.raf = null;
            if (!this.positions.length) return;

            const y = window.pageYOffset +70;
            let current = this.positions[0].key;
            for (let i = 0; i < this.positions.length; i++) {
                if (this.positions[i].top <= y + 2) current = this.positions[i].key;
                else break;
            }
            if (current !== this.state.activeCatKey) {
                this.setState({ activeCatKey: current });
            }
        });
    };

    componentDidMount() {
        let url = BASE_URL_API + "product?market_id=" + this.props.market_id;
        if (this.props.category_id !== -1) url += "&category_id=" + this.props.category_id;

        fetch(url, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((r) => r.json())
            .then((results) => {
                const data = new ProductStructList();

                results.data.forEach((item) => {
                    if (!item.category) return;
                    let group = data.productList.find((p) => p.category === item.category.title);
                    if (!group) {
                        group = new ProductStruct();
                        group.category = item.category.title;
                        data.productList.push(group);
                    }
                    group.productList.push(item);
                });

                data.productList.forEach((group) => {
                    group.productList.sort((a, b) => {
                        const aHasPic = a.pictures && a.pictures.length > 0;
                        const bHasPic = b.pictures && b.pictures.length > 0;
                        if (aHasPic === bHasPic) return 0;
                        return aHasPic ? -1 : 1;
                    });
                });

                this.setState(
                    {
                        productList: data.productList,
                        activeCatKey: data.productList[0]
                            ? this.keyOf(data.productList[0].category)
                            : null,
                    },
                    () => {
                        // measure once the bar is in the DOM
                        setTimeout(() => {
                            this.measureSticky();
                            this.onScrollSpy();
                        }, 0);

                        window.addEventListener("scroll", this.onScrollSpy, { passive: true });
                        window.addEventListener("resize", this.measureSticky);
                    }
                );
            })
            .catch((e) => console.log("error loading products", e));
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.productList !== this.state.productList) {
            setTimeout(this.measureSticky, 0);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScrollSpy);
        window.removeEventListener("resize", this.measureSticky);
        if (this.raf) cancelAnimationFrame(this.raf);
    }

    fmt = (n) => String(n ?? 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    renderPrice(product) {
        const fmt = this.fmt;
        if (Number(product?.del_price) > 0) {
            const finalPrice = Number(product.price) - Number(product.del_price);
            return (
                <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.75, mt: 0.25 }}>
                    <Typography sx={{ fontSize: 12, color: "#8b8b8b", textDecoration: "line-through", whiteSpace: "nowrap" }}>
                        {fmt(product.price)} تومان
                    </Typography>
                    <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#9a1111", whiteSpace: "nowrap" }}>
                        {fmt(finalPrice)} تومان
                    </Typography>
                </Box>
            );
        }
        return (
            <Typography
                sx={{
                    fontSize: 15,
                    fontWeight: 800,
                    color: product.price > 0 ? "#9a1111" : "#666",
                    whiteSpace: "nowrap",
                    mt: 0.25,
                }}
            >
                {product.price > 0 ? fmt(product.price) + " تومان" : "تماس بگیرید."}
            </Typography>
        );
    }

    safeOneLineDesc = (productOrString) => {
        const raw = typeof productOrString === "string" ? productOrString : productOrString?.des ?? "";
        return String(raw).replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
    };

    // ---------- Bottom Sheet ----------
    openSheet = (product) => this.setState({ selected: product, sheetOpen: true });
    closeSheet = () => this.setState({ sheetOpen: false });

    onCardClick = (e, product) => {
        const anchor = e.target.closest("a");
        if (anchor) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.openSheet(product);
    };

    renderSheet() {
        const p = this.state.selected;
        if (!p) return null;

        const cover =
            p.pictures && p.pictures.length > 0
                ? PRODUCT_BASE_URL_API + p.pictures[0].url
                : "hamekara-logo.png";

        const parentCategoryTitle =
            p?.category?.parent?.title ||
            p?.category?.parent_title ||
            p?.category?.category?.title ||
            p?.category_parent_title ||
            "";

        const marketName = this.props.market_name || "";

        return (
            <SwipeableDrawer
                anchor="bottom"
                open={this.state.sheetOpen}
                onOpen={() => this.setState({ sheetOpen: true })}
                onClose={this.closeSheet}
                disableBackdropTransition={this.state.iOS}
                disableDiscovery={this.state.iOS}
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: 18,
                        borderTopRightRadius: 18,
                        pb: 2,
                        direction: "rtl",
                        maxHeight: "80vh",
                    },
                }}
            >
                <Box sx={{ position: "relative", pt: 1.25 }}>
                    <Box
                        sx={{
                            width: 48,
                            height: 4,
                            bgcolor: "rgba(0,0,0,0.2)",
                            borderRadius: 999,
                            mx: "auto",
                            mb: 0.5,
                        }}
                    />
                    <IconButton onClick={this.closeSheet} sx={{ position: "absolute", left: 8, top: 4 }} aria-label="بستن">
                        <CloseRoundedIcon />
                    </IconButton>
                </Box>

                <Box sx={{ px: 2, pb: 1, overflow: "auto" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    bgcolor: "#f5f5f5",
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    width: "fit-content",      // box matches image width
                                    mx: "auto",                // center horizontally
                                }}
                            >
                                <Box
                                    component="img"
                                    src={cover}
                                    alt=""
                                    sx={{
                                        display: "block",
                                        maxHeight: 280,
                                        width: "auto",           // scale width automatically
                                        height: "auto",
                                        objectFit: "contain",
                                    }}
                                />
                            </Box>


                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                <Typography
                                    sx={{
                                        fontFamily: "RokhFaNum, Arial, sans-serif",
                                        fontWeight: 900,
                                        fontSize: 18,
                                        color: "#2a2a2a",
                                        lineHeight: 1.35,
                                        flex: 1,
                                    }}
                                >
                                    {p.title}
                                </Typography>

                                <Box sx={{ display: "flex", gap: 0.5 }}>
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            const url = `${window.location.origin}/market?id=5108&cat=1252`;
                                            if (navigator.share) {
                                                navigator.share({ title: p.title, url }).catch(() => {});
                                            } else {
                                                navigator.clipboard.writeText(url);
                                            }
                                        }}
                                        aria-label="اشتراک‌گذاری"
                                    >
                                        <ShareRoundedIcon />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            navigator.clipboard.writeText(`${window.location.origin}/market?id=5108&cat=1252`)
                                        }
                                        aria-label="کپی"
                                    >
                                        <ContentCopyRoundedIcon />
                                    </IconButton>
                                </Box>
                            </Box>

                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap", mt: 1 }}>
                                {p?.category?.title && (
                                    <Chip
                                        label={p.category.title}
                                        size="small"
                                        sx={{
                                            bgcolor: "#9a1111",
                                            color: "#fff",
                                            fontWeight: 700,
                                            borderRadius: "999px",
                                            height: 22,
                                            fontSize: 12,
                                            flexShrink: 0,
                                            maxWidth: 220,
                                            ".MuiChip-label": {
                                                px: 1,
                                                lineHeight: "20px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                direction: "rtl",
                                            },
                                        }}
                                    />
                                )}
                                {this.props.main_category && (
                                    <Chip
                                        icon={<CategoryOutlinedIcon sx={{ fontSize: 16 }} />}
                                        label={this.props.main_category}
                                        size="small"
                                        sx={{
                                            bgcolor: "#ffeaea",
                                            color: "#9a1111",
                                            fontWeight: 700,
                                            borderRadius: "999px",
                                            height: 22,
                                            fontSize: 12,
                                            flexShrink: 0,
                                            maxWidth: 220,
                                            "& .MuiChip-icon": { color: "#9a1111", mr: 0.5 },
                                            ".MuiChip-label": {
                                                px: 1,
                                                lineHeight: "20px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                direction: "rtl",
                                            },
                                        }}
                                    />
                                )}
                                {parentCategoryTitle && (
                                    <Chip
                                        icon={<CategoryOutlinedIcon sx={{ fontSize: 16 }} />}
                                        label={parentCategoryTitle}
                                        size="small"
                                        sx={{
                                            bgcolor: "#f0f0f0",
                                            color: "#333",
                                            fontWeight: 700,
                                            borderRadius: "999px",
                                            height: 22,
                                            fontSize: 12,
                                            flexShrink: 0,
                                            maxWidth: 220,
                                            "& .MuiChip-icon": { color: "#777", mr: 0.5 },
                                            ".MuiChip-label": {
                                                px: 1,
                                                lineHeight: "20px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                direction: "rtl",
                                            },
                                        }}
                                    />
                                )}
                                {marketName && (
                                    <Chip
                                        icon={<StorefrontOutlinedIcon sx={{ fontSize: 16 }} />}
                                        label={marketName}
                                        size="small"
                                        variant="outlined"
                                        sx={{
                                            borderColor: "#9a1111",
                                            color: "#9a1111",
                                            fontWeight: 700,
                                            borderRadius: "999px",
                                            height: 22,
                                            fontSize: 12,
                                            flexShrink: 0,
                                            maxWidth: 220,
                                            "& .MuiChip-icon": { color: "#9a1111", mr: 0.5 },
                                            ".MuiChip-label": {
                                                px: 1,
                                                lineHeight: "20px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                direction: "rtl",
                                            },
                                        }}
                                    />
                                )}
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexDirection: "row-reverse",
                                    gap: 1,
                                    mt: 1,
                                }}
                            >
                                {this.renderPrice(p)}
                                {p.step != null && Number(p.step) > 0 && (
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "text.secondary",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.5,
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        <Inventory2Icon fontSize="small" />
                                        موجودی: {Number(p.step).toLocaleString("en", { maximumFractionDigits: 4 })}
                                    </Typography>
                                )}
                            </Box>

                            {(p.barcode || p.id) && (
                                <Typography sx={{ mt: 0.75, fontSize: 12.5, color: "#555" }}>
                                    بارکد: <b style={{ letterSpacing: 0.5 }}>{p.barcode || p.id}</b>
                                </Typography>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            <Divider sx={{ my: 1 }} />
                            <Typography sx={{ fontSize: 13.5, color: "#333", lineHeight: 1.7, whiteSpace: "pre-wrap" }}>
                                {this.safeOneLineDesc(p.des) || "—"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={<ArrowForwardIosRoundedIcon />}
                                sx={{
                                    bgcolor: "#9a1111",
                                    "&:hover": { bgcolor: "#7e0f0f" },
                                    fontWeight: 800,
                                    columnGap: 2,
                                    "& .MuiButton-startIcon": { mr: 1.5, ml: 0 },
                                }}
                                onClick={() => this.closeSheet()}
                            >
                                بازگشت به منو
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </SwipeableDrawer>
        );
    }

    // ---------- Card ----------
    renderProductCard = (product) => {
        const cover =
            product.pictures && product.pictures.length > 0
                ? PRODUCT_BASE_URL_API + product.pictures[0].url
                : "https://hamekara.com/hamekara-logo.png";

        const marketName = this.props.market_name || "";
        const parentCategoryTitle =
            product?.category?.parent?.title ||
            product?.category?.parent_title ||
            product?.category?.category?.title ||
            product?.category_parent_title ||
            "";

        return (
            <Paper
                key={product.id}
                elevation={1}
                onClick={(e) => this.onCardClick(e, product)}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && this.onCardClick(e, product)}
                role="button"
                tabIndex={0}
                sx={{
                    width: { xs: "100%", sm: 320, md: 336 },
                    flex: "0 0 auto",
                    mb: { xs: 1.25, md: 0 },
                    px: 1,
                    py: 1,
                    borderRadius: 3,
                    bgcolor: "#fff",
                    boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
                    direction: "rtl",
                    cursor: "pointer",
                    "& a": { pointerEvents: "none" },
                }}
            >
                <Grid container spacing={1} alignItems="stretch">
                    {/* Image right */}
                    <Grid item xs={4}>
                        <Box
                            sx={{
                                position: "relative",
                                height: 104,
                                borderRadius: 3,
                                overflow: "hidden",
                                boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.04)",
                                bgcolor: "#f5f5f5",
                            }}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "58%",
                                    height: "58%",
                                    borderBottomRightRadius: 22,
                                }}
                            />
                            <Box
                                component="img"
                                src={cover}
                                alt=""
                                sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
                            />
                        </Box>
                    </Grid>

                    {/* Info left */}
                    <Grid item xs={8}>
                        <Box
                            sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                pr: { xs: 0.5, sm: 0.75 },
                            }}
                        >
                            <Typography
                                sx={{
                                    textDecoration: "none",
                                    fontFamily: "RokhFaNum, Arial, sans-serif",
                                    fontWeight: 900,
                                    fontSize: 16,
                                    color: "#2a2a2a",
                                    lineHeight: 1.4,
                                }}
                                title={product.title}
                            >
                                {product.title}
                            </Typography>

                            <Typography
                                sx={{
                                    mt: 0.25,
                                    fontSize: 12.5,
                                    color: "#666",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 1,
                                    WebkitBoxOrient: "vertical",
                                    lineHeight: 1.4,
                                    direction: "rtl",
                                }}
                                title={this.safeOneLineDesc(product.des)}
                            >
                                {this.safeOneLineDesc(product)}
                            </Typography>

                            {/* Chips row */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, my: 0.25, flexWrap: "wrap" }}>
                                {product?.category?.title && (
                                    <Chip
                                        label={product.category.title}
                                        size="small"
                                        sx={{
                                            bgcolor: "#9a1111",
                                            color: "#fff",
                                            fontWeight: 700,
                                            borderRadius: "999px",
                                            height: 20,
                                            fontSize: 12,
                                            flexShrink: 0,
                                            maxWidth: 180,
                                            ".MuiChip-label": {
                                                px: 1,
                                                lineHeight: "18px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                direction: "rtl",
                                            },
                                        }}
                                    />
                                )}

                                {this.props.main_category && (
                                    <Chip
                                        icon={<CategoryOutlinedIcon sx={{ fontSize: 16 }} />}
                                        label={this.props.main_category}
                                        size="small"
                                        sx={{
                                            bgcolor: "#ffeaea",
                                            color: "#9a1111",
                                            fontWeight: 700,
                                            borderRadius: "999px",
                                            height: 20,
                                            fontSize: 12,
                                            flexShrink: 0,
                                            maxWidth: 180,
                                            "& .MuiChip-icon": { color: "#9a1111", mr: 0.5 },
                                            ".MuiChip-label": {
                                                px: 1,
                                                lineHeight: "18px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                direction: "rtl",
                                            },
                                        }}
                                    />
                                )}

                                {parentCategoryTitle && (
                                    <Chip
                                        icon={<CategoryOutlinedIcon sx={{ fontSize: 16 }} />}
                                        label={parentCategoryTitle}
                                        size="small"
                                        sx={{
                                            bgcolor: "#f0f0f0",
                                            color: "#333",
                                            fontWeight: 700,
                                            borderRadius: "999px",
                                            height: 20,
                                            fontSize: 12,
                                            flexShrink: 0,
                                            maxWidth: 180,
                                            "& .MuiChip-icon": { color: "#777", mr: 0.5 },
                                            ".MuiChip-label": {
                                                px: 1,
                                                lineHeight: "18px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                direction: "rtl",
                                            },
                                        }}
                                    />
                                )}
                                {marketName && (
                                    <Chip
                                        icon={<StorefrontOutlinedIcon sx={{ fontSize: 16 }} />}
                                        label={marketName}
                                        size="small"
                                        variant="outlined"
                                        sx={{
                                            borderColor: "#9a1111",
                                            color: "#9a1111",
                                            fontWeight: 700,
                                            borderRadius: "999px",
                                            height: 20,
                                            fontSize: 12,
                                            flexShrink: 0,
                                            maxWidth: 180,
                                            "& .MuiChip-icon": { color: "#9a1111", mr: 0.5 },
                                            ".MuiChip-label": {
                                                px: 1,
                                                lineHeight: "18px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                direction: "rtl",
                                            },
                                        }}
                                    />
                                )}
                            </Box>

                            {/* Price + Stock */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexDirection: "row-reverse",
                                    flexWrap: "wrap",
                                    gap: 1,
                                }}
                            >
                                {this.renderPrice(product)}
                                {product.step != null && Number(product.step) > 0 && (
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "text.secondary",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.5,
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        <Inventory2Icon fontSize="small" />
                                        موجودی: {Number(product.step).toLocaleString("en", { maximumFractionDigits: 4 })}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        );
    };

    // ---------- RENDER ----------
    render() {
        const cats = this.state.productList.map((g) => ({
            label: g.category,
            key: this.keyOf(g.category),
        }));

        const { activeCatKey, stickyTotal } = this.state;

        return (
            <>
                {/* Sticky categories bar */}
                <Box
                    ref={(el) => (this.topBarRef = el)}
                    sx={{
                        position: "sticky",
                        top: (this.props.stickyOffset ?? 75) - 1,
                        zIndex: 5,
                        bgcolor: "#ffffff",
                        borderBottom: "1px solid #eee",
                        py: 0.75,
                        px: { xs: 1, md: 2 },
                        direction: "rtl",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            gap: 0.75,
                            overflowX: "auto",
                            overflowY: "hidden",
                            pb: 0.25,
                            "&::-webkit-scrollbar": { height: 0 },
                            "& > *": { flex: "0 0 auto" },
                        }}
                    >
                        {cats.map((c) => {
                            const isActive = activeCatKey === c.key;
                            return (
                                <Chip
                                    key={c.key}
                                    onClick={() => this.scrollToCategory(c.key)}
                                    label={c.label}
                                    clickable
                                    sx={{
                                        fontWeight: 800,
                                        borderRadius: "999px",
                                        height: 30,
                                        flexShrink: 0,
                                        maxWidth: "72vw",
                                        bgcolor: isActive ? "#9a1111" : "#f6f6f6",
                                        color: isActive ? "#fff" : "#333",
                                        border: isActive ? "none" : "1px solid #e6e6e6",
                                        "&:hover": { bgcolor: isActive ? "#7e0f0f" : "#ececec" },
                                        whiteSpace: "nowrap",
                                        ".MuiChip-label": {
                                            px: 1.25,
                                            lineHeight: "28px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            direction: "rtl",
                                        },
                                    }}
                                />
                            );
                        })}
                    </Box>
                </Box>

                {/* Sections */}
                {this.state.productList.map((group) => {
                    const key = this.keyOf(group.category);
                    return (
                        <Box
                            key={key}
                            data-cat={group.category}
                            data-key={key}
                            ref={(el) => {
                                if (el) this.categoryRefs.set(key, el);
                            }}
                            sx={{ mb: 2, px: { xs: 0.75, sm: 1 } }}
                        >
                            <Grid container alignItems="center" sx={{ direction: "rtl", mb: 0.75, px: { xs: 0.5, md: 0 } }}>
                                <Grid item xs={8} sm={10} md={10} lg={11}>
                                    <Typography
                                        ref={(el) => {
                                            if (el) this.categoryTitleRefs.set(key, el);
                                        }}
                                        sx={{
                                            fontSize: 15.5,
                                            fontWeight: 800,
                                            // CSS fallback when using scrollIntoView directly:
                                            scrollMarginTop: stickyTotal,
                                        }}
                                    >
                                        {group.category}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", sm: "row" },
                                    alignItems: { xs: "center", sm: "stretch" },
                                    gap: 1.25,
                                    overflowX: { xs: "hidden", sm: "auto" },
                                    overflowY: "visible",
                                    pb: 0.5,
                                    px: { xs: 0, sm: 0.5 },
                                }}
                            >
                                {group.productList.slice(0, 20).map((p) => this.renderProductCard(p))}
                            </Box>
                        </Box>
                    );
                })}

                {this.renderSheet()}
            </>
        );
    }
}
